import sizeCharts from "./sizeCharts";
import sizeChartsWithId from "./sizeChartsWithId";
export default { ...sizeCharts, ...sizeChartsWithId };
